import styled from "styled-components"

export const withCentered = (Component) => styled(Component)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;